import React, { useContext, useEffect, useState, useRef } from "react";
import {
    getRawMaterials,
    deleteRawMaterials,
    updateRawMaterials,
    createRawMaterials,
    getUnits,
    getRawMaterialBatches,
    adjustRawMaterialStock
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { isReadonlyRoute, NaviGate } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import { useLocation, useNavigate } from "react-router-dom"
import { EditRawMaterials } from "./rform";

const RawMaterials = () => {
    const { showLoader, hideLoader, shopItem, warehouse, UserItem } = useContext(WarehouseContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const readonly = isReadonlyRoute(pathname);

    const [rawmaterials, setRawmaterials] = useState([]);
    const [selectedRaw, setSelectedRaw] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [addOrEdit, setAddOrEdit] = useState(true);

    const [deleteID, setDeleteID] = useState("");
    const [deletemodel, showDeletemodel] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const rolesPerPage = 10;
    const [unitsList, setUnitsList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const isMounted = useRef(false);

    const [batches, setBatches] = useState([]);
    const [showAdjustModal, setShowAdjustModal] = useState(false);
    const [adjustRawMaterial, setAdjustRawMaterial] = useState(null);
    const [editingBatchId, setEditingBatchId] = useState(null);
    const [newQtyValue, setNewQtyValue] = useState("");

    const openAdjustModal = async (raw) => {
        setAdjustRawMaterial(raw);
        setEditingBatchId(null);
        setNewQtyValue("");
        showLoader();
        try {
            const response = await getRawMaterialBatches(raw.id, shopItem?.id);
            if (response.data && response.data.data) {
                setBatches(response.data.data);
            } else {
                setBatches([]);
            }
            setShowAdjustModal(true);
        } catch (error) {
            console.error("Error fetching raw material batches:", error);
            toast.error("Failed to load stock batches");
        } finally {
            hideLoader();
        }
    };

    const handleAdjustSubmit = async (batch) => {
        if (!newQtyValue || isNaN(newQtyValue) || parseFloat(newQtyValue) < 0) {
            toast.error("Please enter a valid quantity");
            return;
        }
        showLoader();
        try {
            const payload = {
                transaction_id: batch.id,
                qty: parseFloat(newQtyValue),
                shop_id: shopItem?.id,
                user_id: UserItem?.user_id || "0",
            };
            const response = await adjustRawMaterialStock(payload);
            if (response.data && response.data.status === "success") {
                toast.success("Stock adjusted successfully");
                setEditingBatchId(null);
                setNewQtyValue("");
                // Refresh batches list
                const refreshed = await getRawMaterialBatches(adjustRawMaterial.id, shopItem?.id);
                if (refreshed.data && refreshed.data.data) {
                    setBatches(refreshed.data.data);
                }
                // Refresh main raw materials list
                fetchRawmaterials(currentPage, searchText);
            } else {
                toast.error(response.data.message || "Failed to adjust stock");
            }
        } catch (error) {
            console.error("Error adjusting stock:", error);
            toast.error(error.response?.data?.message || "Failed to adjust stock");
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        fetchRawmaterials();
        fetchUnitsList();
    }, []);

    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unitId) => {
        if (!unitId) return "";
        const found = unitsList.find(u => String(u.id) === String(unitId));
        if (found) return found.title;
        if (String(unitId) === "1") return "kg";
        if (String(unitId) === "2") return "gram";
        if (String(unitId).toLowerCase() === "li") return "li";
        return unitId;
    };

    const handledeletemodel = (ID) => {
        showDeletemodel(true);
        setDeleteID(ID);
    };

    const fetchRawmaterials = async (page = 1, text = "") => {
        showLoader();
        try {
            const response = await getRawMaterials({
                shop_id: shopItem?.id,
                page,
                search: text
            });
            if (response.data && response.data.data) {
                setRawmaterials(response.data.data);
                setTotalPages(response.data.pagination?.total_pages || 1);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        } finally {
            hideLoader();
        }
    };

    const openAddModal = () => {
        setAddOrEdit(true);
        setSelectedRaw(null);
        console.log('clicked')
        setShowEditModal(true);
    };

    const openEditModal = (raw) => {
        setSelectedRaw(raw);
        setAddOrEdit(false);
        console.log('clicked  222')

        setShowEditModal(true);
    };

    const handleDelete = async () => {
        if (!deleteID) {
            toast.error("No raw material selected to delete");
            return;
        }

        try {
            await deleteRawMaterials(deleteID);
            showDeletemodel(false);
            toast.success("Raw material deleted");
            fetchRawmaterials(currentPage);
        } catch (error) {
            console.error("Error deleting raw material:", error);
            toast.error("Error deleting raw material");
        }
    };

    const handlePageChange = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
        fetchRawmaterials(pageNumber, searchText);
    };

    useEffect(() => {
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }

        const delayDebounceFn = setTimeout(() => {
            setSearchText(searchInput);
            fetchRawmaterials(1, searchInput);
            setCurrentPage(1);
        }, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [searchInput]);

    const activateRawMaterial = async (value) => {
        showLoader();
        try {
            const payload = {
                ...value,
                status: "active",
            };
            await updateRawMaterials(value?.id, payload);
            fetchRawmaterials(currentPage);
            toast.success("Raw material activated");
        } catch (err) {
            console.error(err);
            toast.error(err.message);
        } finally {
            hideLoader();
        }
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6
                        className="mb-0 text-uppercase"
                        style={{ fontFamily: "poppins" }}
                    >
                        Raw Materials List
                    </h6>
                    {!readonly && (
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                onClick={() => navigate("/purchase")}
                                className="btn btn-success mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                RM Purchase
                            </button>
                            <button
                                type="button"
                                onClick={() => openAddModal()}
                                className="btn btn-primary mb-0"
                                style={{ fontFamily: "poppins" }}
                            >
                                Add Raw Material
                            </button>
                        </div>
                    )}
                </div>
                <hr className="mt-1" />

                <div className="card">
                    <div className="card-body">
                        <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                            <div
                                className="d-flex position-relative"
                                style={{ width: "100%" }}
                            >
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Search..."
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                                <img
                                    src="/assets/images/icons/search.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        right: "12px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "18px",
                                        pointerEvents: "none",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table
                                className="table table-striped table-sm table-bordered"
                                style={{ width: "100%", fontFamily: "poppins" }}
                            >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Title</th>
                                        <th>Type</th>
                                        <th>Product Code</th>
                                        <th>Reorder Point</th>
                                        <th>Stocks Available</th>
                                        {/* <th>Status</th> */}
                                        {/* <th>Created By</th> */}
                                        {!readonly && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rawmaterials.map((raw, index) => (
                                        <tr key={raw.id}>
                                            <td>{(currentPage - 1) * rolesPerPage + index + 1}</td>
                                            <td>{raw.title}</td>
                                            <td>{raw.type == "1" ? "Packaging material" : raw.type == "2" ? "Litre" : "Spices"}</td>
                                            <td>{raw.product_code}</td>
                                            <td>{raw.reorder_point}</td>
                                            <td>{parseFloat(raw.remaining_stock || 0).toFixed(2)} {raw.type == "2" ? "li" : getUnitName(raw.unit_id)}</td>
                                            {/* <td>{raw.status}</td> */}
                                            {/* <td>{raw.created_by}</td> */}
                                            {!readonly && (
                                                <td>
                                                    <>
                                                         <img
                                                             src="/assets/images/icons/edit.png"
                                                             onClick={() => openEditModal(raw)}
                                                             height="16px"
                                                             alt="Edit"
                                                             style={{ cursor: "pointer" }}
                                                             title="Edit"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         <img
                                                             src="/assets/images/icons/transfer-switch.png"
                                                             onClick={() => openAdjustModal(raw)}
                                                             height="16px"
                                                             alt="Adjust Stock"
                                                             style={{ cursor: "pointer" }}
                                                             title="Adjust Stock"
                                                         />
                                                         &nbsp;&nbsp;&nbsp;
                                                         <img
                                                             src="/assets/images/icons/delete.png"
                                                             onClick={() => handledeletemodel(raw.id)}
                                                             height="16px"
                                                             alt="Delete"
                                                             style={{ cursor: "pointer" }}
                                                             title="Delete"
                                                         />
                                                    </>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {deletemodel && (
                <Deletemodel
                    setShowModal={showDeletemodel}
                    handleDelete={handleDelete}
                />
            )}

            {/* {showEditModal && ( */}
            <EditRawMaterials
                showModal={showEditModal}
                // setShowModal={() => setShowEditModal(false)}
                setShowModal={() => {
                    setShowEditModal(false);
                    setSelectedRaw(null);
                }}
                fetchRawmaterials={() => fetchRawmaterials()}
                selectedRawmaterial={selectedRaw}
                AddorEdit={addOrEdit}
            />

            {showAdjustModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060 }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content border-0 rounded-3 shadow">
                            <div className="modal-header px-4 py-3 bg-light d-flex justify-content-between align-items-center">
                                <h5 className="modal-title font-bold text-dark" style={{ fontFamily: "poppins" }}>
                                    Stock Adjustment: {adjustRawMaterial?.title}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowAdjustModal(false)}
                                ></button>
                            </div>
                            <div className="modal-body p-4" style={{ fontFamily: "poppins", maxHeight: "60vh", overflowY: "auto" }}>
                                <div className="alert alert-warning text-xs py-2 px-3 rounded-lg mb-3">
                                    <strong>Note:</strong> You can adjust any active batch that has remaining stock. Fully consumed batches (remaining = 0.00) are locked to preserve production records and general ledger integrity.
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-sm table-bordered align-middle text-xs">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Batch No</th>
                                                <th>MFG Date</th>
                                                <th>EXP Date</th>
                                                <th>Price Unit</th>
                                                <th>Original Qty</th>
                                                <th>Remaining Qty</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {batches.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center text-secondary py-3">No active stock batches found for this raw material.</td>
                                                </tr>
                                            ) : (
                                                batches.map((batch) => {
                                                    const isFullyConsumed = parseFloat(batch.remaining || 0) <= 0;
                                                    const isEditing = editingBatchId === batch.id;
                                                    return (
                                                        <tr key={batch.id} className={isFullyConsumed ? "table-light text-muted" : ""}>
                                                            <td>{batch.batch_no || batch.transaction_id || "-"}</td>
                                                            <td>{batch.mfgdate || "-"}</td>
                                                            <td>{batch.expdate || "-"}</td>
                                                            <td>{parseFloat(batch.price_unit || 0).toFixed(2)}</td>
                                                            <td>{parseFloat(batch.qty || 0).toFixed(2)}</td>
                                                            <td className="font-semibold">{parseFloat(batch.remaining || 0).toFixed(2)}</td>
                                                            <td>
                                                                {isFullyConsumed ? (
                                                                    <span className="badge bg-secondary text-white px-2 py-1 rounded">Consumed (Locked)</span>
                                                                ) : isEditing ? (
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <input
                                                                            type="number"
                                                                            step="any"
                                                                            min="0"
                                                                            className="form-control form-control-sm text-xs py-0.5 px-1.5"
                                                                            style={{ width: "80px" }}
                                                                            value={newQtyValue}
                                                                            onChange={(e) => setNewQtyValue(e.target.value)}
                                                                            onWheel={(e) => e.currentTarget.blur()}
                                                                            placeholder="Qty"
                                                                            autoFocus
                                                                        />
                                                                        <button
                                                                            className="btn btn-xs btn-success py-0.5 px-2"
                                                                            onClick={() => handleAdjustSubmit(batch)}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-xs btn-light py-0.5 px-1.5 border"
                                                                            onClick={() => setEditingBatchId(null)}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <button
                                                                        className="btn btn-xs btn-outline-primary py-1 px-2 rounded font-semibold"
                                                                        onClick={() => {
                                                                            setEditingBatchId(batch.id);
                                                                            setNewQtyValue(parseFloat(batch.remaining || 0).toString());
                                                                        }}
                                                                    >
                                                                        Adjust Qty
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer border-t px-4 py-2 bg-light text-end">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-sm"
                                    onClick={() => setShowAdjustModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RawMaterials;
